import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const mapStateToProps = ({ retailerSettings }) => ({
  retailerSettings,
});

const RadioElementWrapperDiv = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
  position: relative;
  box-sizing: border-box;
`;

const RadioButtonDotLabel = styled.label`
  cursor: pointer;
  position: absolute;
  top: 10%;
  left: 2px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: white;
  border: 1px solid #ccc;
`;

const RadioButtonBackgroundInput = styled.input`
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin-right: 10px;
  &:checked + ${RadioButtonDotLabel} {
    background: ${(props) => props.ctaColor || '#2B7CAC'};
    border: 1px solid ${(props) => props.ctaColor || '#2B7CAC'};
    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      margin: 5px;
      box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.1);
      background: white;
    }
  }
`;

const RadioButtonLabel = styled.label`
  flex: 1;
  cursor: pointer;
  position: relative;
  margin: 0 15px 15px 20px;
  font-size: 13px;
  font-weight: normal;
`;

class RefundRadioButton extends React.Component {
  handleInputChange = () => {
    const { refundType, onChangeHandler } = this.props;
    onChangeHandler(refundType);
  };

  render() {
    const {
      label,
      refundType,
      retailerSettings: { branding: { brand_call_to_action: ctaColor } = {} } = {},
      isChecked,
    } = this.props;

    return (
      <RadioElementWrapperDiv>
        <RadioButtonBackgroundInput
          type="radio"
          name="radio"
          id={`radio-${refundType}`}
          ctaColor={ctaColor}
          value={refundType}
          checked={isChecked}
          onChange={this.handleInputChange}
          data-test={`refund-radio-control-${refundType}`}
          tabIndex="0"
        />
        <RadioButtonDotLabel htmlFor={`radio-${refundType}`} />
        <RadioButtonLabel
          data-test={`refund-radio-label-${refundType}`}
          tabIndex="0"
          htmlFor={`radio-${refundType}`}
          dangerouslySetInnerHTML={{
            __html: label,
          }}
        />
      </RadioElementWrapperDiv>
    );
  }
}

RefundRadioButton.propTypes = {
  label: PropTypes.string.isRequired,
  retailerSettings: PropTypes.object.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  refundType: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(RefundRadioButton);
